module.exports = __webpack_public_path__ + "static/media/hero-question-a.43c6c7a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sections/Hero/hero-question-a.svg
// module id = 88
// module chunks = 0